module.exports = __webpack_public_path__ + "static/media/urchin.97db974b.jpg";